import type { MSBRegistration } from '@gcv/shared';
import { injectable } from 'inversify';

import { api } from './api-util/api';

@injectable()
export class MsbsApi {
  async searchForRegistrations(
    orgId: string,
    query?: { registrationNumber?: string }
  ): Promise<MSBRegistration[]> {
    return await api().get(`/msb/${orgId}/registrations-search`, query);
  }
}
